import React from 'react';
import classes from '../../styles/index.module.scss';
import classNames from 'classnames';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';

export const Footer = ({ children, className }) => {
	const componentClasses = classNames(classes.footer, className);

	return (
		<ErrorBoundary>
			<div className={componentClasses}>{children}</div>
		</ErrorBoundary>
	);
};
